

import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const CurrentEmployment = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        contactNumber: "000 000 0000",
        currentLocation: "Delhi",
        reasonForChange: "Other",
        relocate: "Yes",
        currentCtc: "500000",
        expectedCtc: "600000",
        numberofReportes: "2",
        jobGrad: "G4",
        payTemplate: "Salary 1",
        jobType: "Regular",
        workingLocation: "Delhi",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Current Employment</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* Contact Number */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Contact Number</label>
                        {isEditing ? (
                            <input type="text" name="contactNumber" className="form-control input-me f-14" value={formData.contactNumber} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.contactNumber}</p>
                        )}
                    </div>

                    {/* Current Location */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Current Location</label>
                        {isEditing ? (
                            <input type="text" name="currentLocation" className="form-control input-me f-14" value={formData.currentLocation} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.currentLocation}</p>
                        )}
                    </div>
                    {/* Reason For Change */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Reason For Change</label>
                        {isEditing ? (
                            <input type="text" name="reasonForChange" className="form-control input-me f-14" value={formData.reasonForChange} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.reasonForChange}</p>
                        )}
                    </div>
                    {/* Relocate */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Relocate</label>
                        {isEditing ? (
                            <select name="relocate" className="form-control input-me f-14" value={formData.relocate} onChange={handleChange}>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.relocate}</p>
                        )}
                    </div>
                    {/* Current CTC */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Current CTC</label>
                        {isEditing ? (
                            <input type="text" name="currentCtc" className="form-control input-me f-14" value={formData.currentCtc} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.currentCtc}</p>
                        )}
                    </div>
                    {/* Expected CTC */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Expected CTC</label>
                        {isEditing ? (
                            <input type="text" name="expectedCtc" className="form-control input-me f-14" value={formData.expectedCtc} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.expectedCtc}</p>
                        )}
                    </div>
                    {/* Number of Reportes */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Number of Reportes</label>
                        {isEditing ? (
                            <input type="text" name="numberofReportes" className="form-control input-me f-14" value={formData.numberofReportes} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.numberofReportes}</p>
                        )}
                    </div>
                    {/* Job Grad */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Job Grad</label>
                        {isEditing ? (
                            <select name="jobGrad" className="form-control input-me f-14" value={formData.jobGrad} onChange={handleChange}>
                                <option>G3</option>
                                <option>G4</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.jobGrad}</p>
                        )}
                    </div>
                    {/* Pay Template */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Pay Template</label>
                        {isEditing ? (
                            <select name="payTemplate" className="form-control input-me f-14" value={formData.payTemplate} onChange={handleChange}>
                                <option>Salary 1</option>
                                <option>Salary 2</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.payTemplate}</p>
                        )}
                    </div>
                    {/* Job Type */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Job Type</label>
                        {isEditing ? (
                            <select name="jobType" className="form-control input-me f-14" value={formData.jobType} onChange={handleChange}>
                                <option>Regular</option>
                                <option>Contract</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.jobType}</p>
                        )}
                    </div>
                    {/* Working Location */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Working Location</label>
                        {isEditing ? (
                            <input type="text" name="workingLocation" className="form-control input-me f-14" value={formData.workingLocation} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.workingLocation}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CurrentEmployment;
